import { render } from "./app-datatable.vue?vue&type=template&id=6a38b871"
import script from "./app-datatable.vue?vue&type=script&lang=js"
export * from "./app-datatable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__